import { render, staticRenderFns } from "./string-array-input.component.vue?vue&type=template&id=20d5caac&scoped=true"
import script from "./string-array-input.component.vue?vue&type=script&lang=ts"
export * from "./string-array-input.component.vue?vue&type=script&lang=ts"
import style0 from "./string-array-input.component.vue?vue&type=style&index=0&id=20d5caac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5caac",
  null
  
)

export default component.exports